import { makeStyles } from '@focaldata/cin-ui-components'

const useStyles = makeStyles()({
  names: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2
  }
})

export default useStyles
